import React, { FunctionComponent } from 'react';

const AvatarSubtitle: FunctionComponent = ({ children }) => {

    return (
        <div className="axxes-avatar__subtitle">
            {children}
        </div>
    )
}

export default AvatarSubtitle;